import * as Popover from '@radix-ui/react-popover'
import { ReactNode, useState } from 'react'
import ReactDatePicker from 'react-datepicker'

import { ComparatorTrigger } from './ComparatorTrigger'
import { DATE_FNS_LOCALE_OPTIONS } from '../../constants/date'
import { useLocale, useTranslations } from '../../translate'
import { Paper } from '../Paper'

export const ComparatorDateInput = ({
  children,
  value,
  onSelect,
}: {
  value: number | null
  onSelect: (value: number | null) => void
  children?: ReactNode
}) => {
  const t = useTranslations()
  const locale = useLocale()
  const localeOptions = DATE_FNS_LOCALE_OPTIONS[locale]

  const [isOpen, setIsOpen] = useState(true)

  const handleSelect = (selectedValue: Date | null) => {
    setIsOpen(false)
    onSelect(selectedValue ? Math.floor(selectedValue.getTime() / 1000) : null)
  }

  const label = value
    ? t.$date.unix(value).format('ll')
    : t.form.select_a_date()

  return (
    <Popover.Root open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <Popover.Trigger asChild>
        <ComparatorTrigger design="bold">{children ?? label}</ComparatorTrigger>
      </Popover.Trigger>
      <Popover.Content
        sideOffset={4}
        align="center"
        style={{
          /*
            Z index was added since the popover was otherwise rendered under other elements like
            the table in the vacancies list where it was used. Note that the table didn't have any
            z-index set.
          */
          zIndex: 1,
        }}
      >
        <ReactDatePicker
          calendarContainer={({ className, children }) => (
            <Paper className={className}>{children}</Paper>
          )}
          dateFormat={localeOptions.dateFormat.short}
          inline
          locale={localeOptions.locale}
          onChange={handleSelect}
          selected={value ? new Date(value * 1000) : null}
          showWeekNumbers
        />
      </Popover.Content>
    </Popover.Root>
  )
}
